"use client";
import {
  __spreadValues
} from "../../../chunk-MMUBH76A.js";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ModalStep } from "../../utils/steps.js";
import { getActions } from "./actions.js";
import { createRef } from "react";
var OnRampStep = /* @__PURE__ */ ((OnRampStep2) => {
  OnRampStep2[OnRampStep2["SETTINGS"] = 0] = "SETTINGS";
  OnRampStep2[OnRampStep2["PROVIDER"] = 1] = "PROVIDER";
  return OnRampStep2;
})(OnRampStep || {});
const DEFAULT_MODAL_STATE = {
  flow: void 0,
  stepDirection: 1,
  webAuthURLForLogin: void 0,
  webAuthURLForCreate: void 0,
  passwordUrlForLogin: void 0,
  supportedAuthMethods: /* @__PURE__ */ new Set(),
  onModalStepChange: void 0,
  onRampPurchase: void 0,
  onRampStep: 0 /* SETTINGS */,
  isFullyLoggedIn: false,
  accountAddFundTab: void 0,
  isExternalWalletConnecting: false,
  externalWalletError: void 0,
  activeWallet: [void 0, void 0],
  farcasterConnectUri: void 0,
  biometricLocationHints: void 0,
  iFrameUrl: void 0,
  isIFrameReady: void 0,
  refs: {
    popupWindow: createRef(),
    poll: createRef(),
    currentStep: createRef()
  },
  authStepRoute: void 0,
  isPasskeySupported: true
};
const useModalStore = create()(
  persist(
    (set, get) => __spreadValues(__spreadValues({
      step: ModalStep.AUTH_MAIN,
      onRampConfig: void 0,
      activeWallet: void 0
    }, DEFAULT_MODAL_STATE), getActions(set, get)),
    {
      version: 1,
      name: "@PARA/modalState",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        step: state.step,
        webAuthURLForLogin: state.webAuthURLForLogin,
        webAuthURLForCreate: state.webAuthURLForCreate,
        passwordUrlForLogin: state.passwordUrlForLogin,
        biometricLocationHints: state.biometricLocationHints,
        onRampPurchase: state.onRampPurchase,
        selectedExternalWalletId: state.selectedExternalWalletId,
        isUsingMobileConnector: state.isUsingMobileConnector,
        supportedAuthMethods: state.supportedAuthMethods,
        isPasskeySupported: state.isPasskeySupported
      })
    }
  )
);
export {
  DEFAULT_MODAL_STATE,
  OnRampStep,
  useModalStore
};
